import React from 'react';
import FormListItem from './FormListItem';

const FormListItems = ({
  canEdit,
  category,
  code,
  component,
  direction,
  fields,
  hideLabel,
  isEditing,
  onChange,
  saveErrors,
  saveStatus,
  section,
  showEdit,
  text,
}) => fields.map((item, index) => (
  <FormListItem
    autoFocus={index === 0}
    canEdit={canEdit}
    category={category}
    code={code}
    component={component(item)}
    direction={direction}
    field={item}
    hideLabel={hideLabel}
    isEditing={isEditing}
    key={`form_field_${item.name}`}
    onChange={onChange}
    section={section}
    saveErrors={saveErrors}
    saveStatus={saveStatus}
    showEdit={showEdit}
    text={text(item)}
  />
));

export default FormListItems;
